















































































































import { useAdminHsaStoreInfoStore } from "@/admin/store/hsaStoreInfo";
import { AdminDefaultHsaStoreInfo, UserPermission } from "@/shared/types";
import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import * as RouteNames from "@/admin/route-names";

@Component({})
export default class EditDefaultHsaStoreInfo extends Vue {
  isSaving = false;
  adminDefaultHsaInfoStore = useAdminHsaStoreInfoStore();
  hasEditPermission = false;
  rolePermissionsStore = useRolePermissionsStore();
  RouteNames = RouteNames;

  formModel = {
    id: 0,
    name: "",
    logoKey: "",
    altImageText: "",
    logoHeightInPx: 0,
    logoWidthInPx: 0,
    tileHeader: "",
    tileDescription: "",
    storeButtonText: "",
    storeLinkUrl: "",
    eligibilityLinkText: "",
    eligibilityLinkUrl: "",
    enabled: false,
    delayInSeconds: 0,
    displayOrder: 0,
  };

  @Prop()
  storeId: number;

  created () {
    this.setFormModel();
    this.hasEditPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalMarketplaceTileEdit);
  }

  @Watch("storeId", { immediate: true })
  fetchStoreInfo () {
    this.setFormModel();
  }

  setFormModel () {
    if (!this.adminDefaultHsaInfoStore.isDefaultHsaStoreInfosLoaded()) {
      this.adminDefaultHsaInfoStore.loadDefaultStoreInfos().then(() => {
        if (this.storeId) {
          this.mapFormModel();
        }
      });
    }
    else {
      this.mapFormModel();
    }
  }

  mapFormModel () {
    const hsaStoreInfo = this.adminDefaultHsaInfoStore.getDefaultHsaStoreInfoById(this.storeId);

    this.formModel = {
      id: hsaStoreInfo.id,
      name: hsaStoreInfo.name,
      logoKey: hsaStoreInfo.logoKey,
      altImageText: hsaStoreInfo.altImageText,
      logoHeightInPx: hsaStoreInfo.logoHeightInPx,
      logoWidthInPx: hsaStoreInfo.logoWidthInPx,
      tileHeader: hsaStoreInfo.tileHeader,
      tileDescription: hsaStoreInfo.tileDescription,
      storeButtonText: hsaStoreInfo.storeButtonText,
      storeLinkUrl: hsaStoreInfo.storeLinkUrl,
      eligibilityLinkText: hsaStoreInfo.eligibilityLinkText,
      eligibilityLinkUrl: hsaStoreInfo.eligibilityLinkUrl,
      enabled: hsaStoreInfo.enabled,
      delayInSeconds: hsaStoreInfo.delayInSeconds,
      displayOrder: hsaStoreInfo.displayOrder
    };
  }

  get submitDisabled () {
      return this.$validator.errors.any() || this.isSaving;
  }

   onSubmit () {
    this.$validator.validate().then(result => {
      if (!result) {
        return;
      }
      this.isSaving = true;
      this.adminDefaultHsaInfoStore.saveDefaultHsaStoreInfos([this.formModel]).finally(() => {
        this.isSaving = false;
      });
    });
  }

  beforeMount () {
    this.$validator.extend("validateStoreLinkUrl", {
      getMessage: _ => {
        return "Please enter a valid URL.";
      },
      validate: _ => {
        const result = { valid: true, data: { required: true } };
        if (!this.formModel.storeLinkUrl) {
          result.valid = false;
          return result;
        }

        const url = this.formModel.storeLinkUrl.toLowerCase().trim();
        if (url.startsWith("https://")) {
          try {
            const url = new URL(this.formModel.storeLinkUrl as string);
          } catch {
            result.valid = false;
          }
        } else {
          result.valid = false;
        }

        return result;
      }
    }, {
      computesRequired: true
    });
    this.$validator.extend("validateEligibilityLinkUrl", {
      getMessage: _ => {
        return "Please enter a valid URL.";
      },
      validate: _ => {
        const result = { valid: true, data: { required: true } };
        if (!this.formModel.eligibilityLinkUrl) {
          result.valid = false;
          return result;
        }

        const url = this.formModel.eligibilityLinkUrl.toLowerCase().trim();
        if (url.startsWith("https://")) {
          try {
            const url = new URL(this.formModel.eligibilityLinkUrl as string);
          } catch {
            result.valid = false;
          }
        } else {
          result.valid = false;
        }

        return result;
      }
    }, {
      computesRequired: true
    });
  }
}
